import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Flex,
  Text,
  Input,
  VStack,
  HStack,
  IconButton,
} from "@chakra-ui/react";
import { FaTrash } from "react-icons/fa";

const SignerFormCard = ({ addSigner, index }) => {
  const [signer, setSigner] = useState({
    name: "",
    email: "",
    company: "",
    address: "",
  });

  const handleAdd = () => {
    addSigner(signer);
    setSigner({
      name: "",
      email: "",
      company: "",
      address: "",
    });
  };

  return (
    <VStack
      p={4}
      border="1px"
      borderColor="gray.300"
      borderRadius="md"
      mb={4}
      w="100%"
      maxWidth="300px"
    >
      <FormControl id={`name-${index}`} mb="4" flex="1">
        <FormLabel>Name</FormLabel>
        <Input
          value={signer.name}
          onChange={(e) => setSigner({ ...signer, name: e.target.value })}
        />
      </FormControl>
      <FormControl id={`email-${index}`} mb="4" flex="1">
        <FormLabel>Email</FormLabel>
        <Input
          value={signer.email}
          onChange={(e) => setSigner({ ...signer, email: e.target.value })}
        />
      </FormControl>

      <FormControl id={`company-${index}`} mb="4">
        <FormLabel>Company (optional)</FormLabel>
        <Input
          value={signer.company}
          onChange={(e) => setSigner({ ...signer, company: e.target.value })}
        />
      </FormControl>

      <FormControl id={`address-${index}`} mb="4">
        <FormLabel>Address (optional)</FormLabel>
        <textarea
          value={signer.address}
          onChange={(e) => setSigner({ ...signer, address: e.target.value })}
          style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
        />
      </FormControl>

      <Flex mt={4} alignItems="center" direction="column" width="100%" gap="1em">
        {signer.email !== "" && !signer.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) && (
          <Text color="red">Please enter a valid email</Text>
        )}
        <Button
          onClick={handleAdd}
          isDisabled={
            signer.name === "" ||
            signer.email === "" ||
            !signer.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
          }
          bgColor="black"
          color="white"
          _hover={{ color: "black", bgColor: "gray.200" }}
        >
          Add Signer
        </Button>
      </Flex>
    </VStack>
  );
};

const SignerCard = ({ signer, onDelete }) => (
  <Flex
    gap={2}
    p={3}
    direction="column"
    border="1px"
    borderColor="gray.300"
    borderRadius="md"
    mb={4}
    position="relative"
  >
    <IconButton
      icon={<FaTrash />}
      position="absolute"
      right={2}
      top={2}
      aria-label="Delete Signer"
      background="transparent"
      color="red.500"
      onClick={onDelete}
      _hover={{ bgColor: "none", color: "red.600" }}
    />
    <Text fontWeight="bold">{signer.name}</Text>
    <Text>{signer.email}</Text>
  </Flex>
);

function Step2({ setFormData, formData, setCurrentStep }) {
  const [signers, setSigners] = useState(formData?.signers || []);

  const addSigner = (signer) => {
    setSigners([...signers, signer]);
  };

  const deleteSigner = (indexToDelete) => {
    const updatedSigners = signers.filter((_, index) => index !== indexToDelete);
    setSigners(updatedSigners);
  };

  const handleNext = () => {
    setFormData({ ...formData, signers });
    setCurrentStep(3);
  };

  return (
    <Flex width="100%" alignItems="center" direction="column" gap="2rem" p="2rem">
      <Flex direction="row" gap="2rem" flexWrap="wrap" width="100%">
        {signers?.map((signer, index) => (
          <SignerCard key={index} signer={signer} onDelete={() => deleteSigner(index)} /> // Pass onDelete prop here
        ))}
      </Flex>

      <SignerFormCard addSigner={addSigner} index={signers.length + 1} />

      <Flex justifyContent="space-between" width="100%">
        <Button
          onClick={() => setCurrentStep(1)}
          bgColor="gray.200"
          color="black"
          _hover={{ color: "white", bgColor: "navy.400" }}
        >
          Back
        </Button>
        <Button
          isDisabled={signers.length < 2}
          onClick={handleNext}
          bgColor="navy.400"
          color="white"
          _hover={{ color: "black", bgColor: "gray.200" }}
        >
          Next
        </Button>
      </Flex>
    </Flex>
  );
}

export default Step2;
